export const firebaseAPIKey = (import.meta.env.VITE_FIREBASE_API_KEY ?? "").trim();
export const firebaseMeasurementId = (import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? "").trim();
export const firebaseAuthDomain = (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "").trim();
export const firebaseProjectId = (import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "").trim();
export const firebaseAppId = (import.meta.env.VITE_FIREBASE_APP_ID ?? "").trim();
export const firebaseStorageBucket = (import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "").trim();
export const firebaseMessagingSenderId = (import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "").trim();
export const firebaseKey = `myb_cv_${import.meta.env.VITE_ENV ?? "local"}`;
export const isProd = import.meta.env.VITE_ENV === "production";
